import { Translates } from '@/services/repository/i18n'
import React, { useState, useEffect } from 'react'

export interface SearchInputProps {
  onDebouncedChange: (value: string) => void
  delay?: number
  translates: Translates
}

export const SearchInput: React.FC<SearchInputProps> = ({
  onDebouncedChange,
  delay = 600,
  translates
}) => {
  const [inputValue, setInputValue] = useState<string>('')

  useEffect(() => {
    // Debounce logic
    const handler = setTimeout(() => {
      onDebouncedChange(inputValue)
    }, delay)

    // Cleanup timeout on value change or component unmount
    return () => {
      clearTimeout(handler)
    }
  }, [inputValue, delay, onDebouncedChange])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value)
  }

  return <div className='search-input'>
    <input
      type='text'
      value={inputValue}
      onChange={handleChange}
      placeholder={translates.for('elements.search.placeholder')}
      
    />
  </div>
}